
import React from 'react';
import { Button } from '@/components/ui/button';
import { Search, Filter } from 'lucide-react';

interface NoResultsFoundProps {
  onClearFilters: () => void;
}

const NoResultsFound: React.FC<NoResultsFoundProps> = ({ onClearFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center bg-white rounded-lg shadow-sm">
      <div className="mb-6 p-5 bg-sauna-orange/10 rounded-full">
        <Search className="h-10 w-10 text-sauna-orange" />
      </div>
      
      <h3 className="text-2xl font-bold text-sauna-navy mb-3">No matching saunas found</h3>
      
      <p className="text-gray-600 mb-6 max-w-lg">
        We couldn't find any saunas that match your current filters.
        Try changing your search criteria or clearing all filters.
      </p>
      
      <Button onClick={onClearFilters} className="bg-sauna-orange hover:bg-sauna-orange/90 text-white flex items-center gap-2 mb-6">
        <Filter className="h-4 w-4" />
        Clear All Filters
      </Button>
      
      <div className="mt-4 p-4 bg-sauna-beige/20 rounded-lg max-w-md border border-sauna-beige/30">
        <h4 className="font-medium text-sauna-navy mb-2">Sauna seeking tip:</h4>
        <p className="text-sm text-gray-600">
          "Try broadening your search or selecting fewer filters to find more sauna experiences!"
        </p>
      </div>
    </div>
  );
};

export default NoResultsFound;
